import { render, staticRenderFns } from "./Top5UmsatzerloeseBereiche.vue?vue&type=template&id=4bb73e30&"
import script from "./Top5UmsatzerloeseBereiche.vue?vue&type=script&lang=ts&"
export * from "./Top5UmsatzerloeseBereiche.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports